import * as React from "react";
import {PureComponent} from "react";
import PageHeaderView from "../body/PageHeaderView";
import ButtonGroupWrapper from "../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import UploadPartsModal from "./UploadPartsModal";

interface State {
	uploadModalVisible: boolean
}

export default class MangeGrahamParts extends PureComponent<{}, State> {
	constructor(props: {}) {
		super(props);
		this.state = {uploadModalVisible: false};
	}

	render() {
		return <PageHeaderView header={"Manage Graham parts"}>
			<ButtonGroupWrapper>
				<ButtonPrimary label={"Import"} onClick={() => this.setState({uploadModalVisible: true})}/>
				<ButtonPrimary label={"Export"} onClick={this.downloadGrahamPartsXlsx}/>
			</ButtonGroupWrapper>
			{this.state.uploadModalVisible && <UploadPartsModal onClose={() => this.setState({uploadModalVisible: false})}/>}
		</PageHeaderView>
	}

	downloadGrahamPartsXlsx = () => {
		window.open(`/api/web/parts/stockist_parts/export`, "_blank");
	}
}